import pdfMake from "pdfmake/build/pdfmake";
import moment from 'moment';
import pdfFonts from "pdfmake/build/vfs_fonts";

export function csvExport(arrData, fileName) {
    let csvContent = "data:text/csv;charset=utf-8,";

    csvContent += [
      Object.keys(arrData[0]).join(","),
      ...arrData.map(item => Object.values(item).join(","))
    ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

    const data = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", `${fileName || 'settlement'}${moment().format('DD-MM-YYYY hh:mm:ss')}.csv`);
    link.click();
}

export function pdfExport(datas, fileName) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    if(!datas.length) return;

    const mockBody = [];

    const headers = Object.keys(datas[0]).map(header => ({
        "text": header,
        "style":"tableHeader",
        fontSize: 7
    }));

    mockBody.push(headers);

    datas.forEach(data => {
        mockBody.push(Object.values(data).map(value => ({
            "text": value,
            fontSize: 7
        })))
    })

    const docDefinition = {
        pageSize: 'A1',
        content: [
            {
                table: {
                    headerRows: 1,
                      body: mockBody
                  }
            }
        ],
        };
        pdfMake.createPdf(docDefinition).download(`${fileName || 'settlement'}${moment().format('DD-MM-YYYY hh:mm:ss')}`);
}